const subscribers: Record<string, any> = {};

type Callback<T> = (data: T) => void;

/**
 * This is used as a messaging layer between our bootstrap code and the many custom
 * React shadow DOM rendered components. This publishes atomic cell state (CellProps)
 * to individual rendered components related to the cell.
 */
export const pubSub = {
  publish<T>(id: string, data: T) {
    if (!subscribers[id]) return;

    subscribers[id].forEach((callback: Callback<T>) => callback(data));
  },
  subscribe<T>(id: string, callback: Callback<T>) {
    if (!subscribers[id]) {
      subscribers[id] = [];
    }

    const index = subscribers[id].push(callback) - 1;

    return {
      unsubscribe() {
        subscribers[id].splice(index, 1);
      }
    };
  }
};